import { environment } from '../../environments/environment';

export class ViewMode {
    private static defaultViewMode: ViewMode;
    private static defaultMobileViewMode: ViewMode;
    private static presentationViewMode: ViewMode;
    private static scrollVieMode: ViewMode;

    slug: string;
    pagesToShow: number;
    imagesToPreload = 0;
    showTopbar: boolean;
    showFooter: boolean;
    showZoom: boolean;
    showPageTurner: boolean;
    widthOfSidebar: number;
    maxZoomLevel: number;

    static getDefaultViewMode(): ViewMode {

        if (!ViewMode.defaultViewMode) {
            const defaultViewMode = new ViewMode();
            defaultViewMode.slug = 'default';
            defaultViewMode.pagesToShow = environment.viewModes.defaultViewMode.pagesToShow;
            defaultViewMode.showFooter = environment.viewModes.defaultViewMode.showFooter;
            defaultViewMode.showTopbar = environment.viewModes.defaultViewMode.showTopbar;
            defaultViewMode.showZoom = environment.viewModes.defaultViewMode.showZoom;
            defaultViewMode.showPageTurner = environment.viewModes.defaultViewMode.showPageTurner;
            defaultViewMode.imagesToPreload = environment.viewModes.defaultViewMode.imagesToPreload;
            defaultViewMode.widthOfSidebar = environment.viewModes.defaultViewMode.widthOfSidebar;
            defaultViewMode.maxZoomLevel = environment.viewModes.defaultViewMode.maxZoomLevel;
            ViewMode.defaultViewMode = defaultViewMode;
        }

        return ViewMode.defaultViewMode;
    }

    static getMobileDefaultViewMode(): ViewMode {

        if (!ViewMode.defaultMobileViewMode) {
            const mobileViewMode = new ViewMode();
            mobileViewMode.slug = 'mobile-default';
            mobileViewMode.pagesToShow = environment.viewModes.defaultMobile.pagesToShow;
            mobileViewMode.showFooter = environment.viewModes.defaultMobile.showFooter;
            mobileViewMode.showTopbar = environment.viewModes.defaultMobile.showTopbar;
            mobileViewMode.showZoom = environment.viewModes.defaultMobile.showZoom;
            mobileViewMode.showPageTurner = environment.viewModes.defaultMobile.showPageTurner;
            mobileViewMode.imagesToPreload = environment.viewModes.defaultMobile.imagesToPreload;
            mobileViewMode.widthOfSidebar = environment.viewModes.defaultMobile.widthOfSidebar;
            mobileViewMode.maxZoomLevel = environment.viewModes.defaultMobile.maxZoomLevel;
            ViewMode.defaultMobileViewMode = mobileViewMode;
        }

        return ViewMode.defaultMobileViewMode;
    }

    static getPresentationViewMode(): ViewMode {
        if (!ViewMode.presentationViewMode) {
            const presentationViewMode = new ViewMode();
            presentationViewMode.slug = 'presentation';
            presentationViewMode.pagesToShow = environment.viewModes.presentationViewMode.pagesToShow;
            presentationViewMode.showFooter = environment.viewModes.presentationViewMode.showFooter;
            presentationViewMode.showTopbar = environment.viewModes.presentationViewMode.showTopbar;
            presentationViewMode.showZoom = environment.viewModes.presentationViewMode.showZoom;
            presentationViewMode.showPageTurner = environment.viewModes.presentationViewMode.showPageTurner;
            presentationViewMode.imagesToPreload = environment.viewModes.presentationViewMode.imagesToPreload;
            presentationViewMode.widthOfSidebar = environment.viewModes.presentationViewMode.widthOfSidebar;
            presentationViewMode.maxZoomLevel = environment.viewModes.presentationViewMode.maxZoomLevel;
            ViewMode.presentationViewMode = presentationViewMode;
        }

        return ViewMode.presentationViewMode;
    }

    static getScrollViewMode(): ViewMode {

        if (!ViewMode.scrollVieMode) {
            const scrollViewMode = new ViewMode();
            scrollViewMode.slug = 'scroll';
            scrollViewMode.pagesToShow = environment.viewModes.scrollViewMode.pagesToShow;
            scrollViewMode.showFooter = environment.viewModes.scrollViewMode.showFooter;
            scrollViewMode.showTopbar = environment.viewModes.scrollViewMode.showTopbar;
            scrollViewMode.showZoom = environment.viewModes.scrollViewMode.showZoom;
            scrollViewMode.showPageTurner = environment.viewModes.scrollViewMode.showPageTurner;
            scrollViewMode.imagesToPreload = environment.viewModes.scrollViewMode.imagesToPreload;
            scrollViewMode.widthOfSidebar = environment.viewModes.scrollViewMode.widthOfSidebar;
            scrollViewMode.maxZoomLevel = environment.viewModes.scrollViewMode.maxZoomLevel;
            ViewMode.scrollVieMode = scrollViewMode;
        }

        return ViewMode.scrollVieMode;
    }

}
